import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "alert-modal",
    closeBtn: _ctx.allowClose
  }, {
    header: _withCtx(() => [...(_cache[0] || (_cache[0] = []))]),
    footer: _withCtx(() => [...(_cache[1] || (_cache[1] = []))]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.alertText), 1)
    ]),
    _: 1
  }, 8, ["closeBtn"]))
}